"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.versionsQuery = exports.useGetAssetVersions = void 0;
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
const versionsQuery = exports.versionsQuery = `
  query statuses(
    $groupId: String!
    $assetId: String!
    $status: [Status!]
  ) {
    asset(
      groupId: $groupId
      assetId: $assetId
      status: $status
    ) {
      otherVersions {
        groupId
        assetId
        version
        status
      }
    }
  }
`;
const useGetAssetVersions = variables => {
  const config = (0, _exchangeReactHooks.useConfig)();
  const fetch = (0, _exchangeReactHooks.useFetch)(config.platform.uri);
  const query = {
    query: versionsQuery,
    variables,
    operationName: 'statuses'
  };
  return async () => {
    var _json$data;
    const response = await fetch('/graph/api/v2/graphql', {
      body: JSON.stringify(query),
      method: 'POST'
    });
    const json = await response.json();
    if (json.errors) {
      var _error$extensions, _error$extensions2;
      const error = json.errors[0];
      const queryError = new _exchangeReactHooks.ExchangeError(error.message, {
        statusCode: (_error$extensions = error.extensions) === null || _error$extensions === void 0 ? void 0 : _error$extensions.status,
        requestId: (_error$extensions2 = error.extensions) === null || _error$extensions2 === void 0 ? void 0 : _error$extensions2.requestId
      });
      throw queryError;
    }
    const versions = (_json$data = json.data) === null || _json$data === void 0 || (_json$data = _json$data.asset) === null || _json$data === void 0 ? void 0 : _json$data.otherVersions;
    return versions;
  };
};
exports.useGetAssetVersions = useGetAssetVersions;
//# sourceMappingURL=hooks.js.map